<template>
    <div id="Cantidad">
        <b-button @click="setCantidades" pill size="sm">Cantidad</b-button>
       
        <span v-for="item in CantidadesSeleccionadas" style="font-size:12px">
            {{item.color}} :
            {{item.cantidad}}
        </span>
        <b-toast id="example-toast" title="Ingrese las cantidades a solicitar" static no-auto-hide width="100px">
            <b-row>
                <b-col v-for="item in selectcantidades" cols="3">
                    <span style="font-size:12px">{{item.color}}</span>
                    <b-form-input type="number" v-model="item.cantidad" size="sm" style="font-size:12px"></b-form-input>
                </b-col>

            </b-row>

            <br />
            <b-col><b-button variant="outline-primary" block size="sm" pill v-on:click="$emit('AddCantidades', confirmar())">Confirmar</b-button></b-col>

        </b-toast>
    </div>

</template>

<script>

    export default {
      name:'Cantidad',
            props: {
                tipo: String,
               colores: Array

            },
        data: function () {
            return {
                cantidades:[]
            }
        },
      
          watch:{
            'colores'() {
             
                  this.$emit('update:colores', this.colores);
                return this.colores;           
               }
        },
      
    

        computed: {
            CantidadesSeleccionadas: {
                get: function () {
                    let aux = this.cantidades.filter(x => x.cantidad > 0);                 
                    return aux;
                },
            },
            selectcantidades: {
                get: function () {

                  
                    this.cantidades = this.colores;
                    return this.cantidades;


                },
                set: function (valores) {
                    this.cantidades = valores;
                }
            }
            

        },
      
     
        methods: {
            setCantidades: function () {
           
                this.$bvToast.show('example-toast');
               
            },
            confirmar() {
                this.$bvToast.hide('example-toast');
                return this.cantidades;
            },
           
        }



    };
</script>

<style scoped>
</style>